import { useContactsDefaultContactListQuery } from "@/services/backend/contacts/api/default-contact-api";
import { RTKQueryErrorAlert } from "@/shared/components/errors/rtk-query-error-alert";
import {
  MilestonePage,
  MilestonePageContent,
  MilestonePageHeader,
  MilestonePageTitle,
} from "@/shared/bsm/core/milestone/components/ui/milestone-page";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/shared/components/ui/table";
import t from "@/lang/lang";
import { TableCard } from "@/shared/components/tables/table-card";
import { Skeleton } from "@/shared/components/ui/skeleton";

export function ProcessContactsPage({ processId }: { processId: string }) {
  const {
    data: contacts,
    isLoading,
    error,
  } = useContactsDefaultContactListQuery({ processId });

  return (
    <MilestonePage>
      <MilestonePageHeader>
        <MilestonePageTitle>{t("Ansprechpartner")}</MilestonePageTitle>
      </MilestonePageHeader>
      <MilestonePageContent>
        <TableCard>
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>{t("Name")}</TableHead>
                <TableHead>{t("Funktion")}</TableHead>
                <TableHead>{t("Telefon")}</TableHead>
                <TableHead>{t("Mobil")}</TableHead>
                <TableHead>{t("E-Mail")}</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {error && (
                <TableRow>
                  <TableCell>
                    <RTKQueryErrorAlert error={error} />
                  </TableCell>
                </TableRow>
              )}
              {isLoading && (
                <TableRow>
                  <TableCell>
                    <Skeleton className="h-3 w-24" />
                  </TableCell>
                  <TableCell>
                    <Skeleton className="h-3 w-24" />
                  </TableCell>
                  <TableCell>
                    <Skeleton className="h-3 w-24" />
                  </TableCell>
                  <TableCell>
                    <Skeleton className="h-3 w-24" />
                  </TableCell>
                  <TableCell>
                    <Skeleton className="h-3 w-24" />
                  </TableCell>
                </TableRow>
              )}
              {contacts?.contacts?.map((contact) => (
                <TableRow key={contact.id}>
                  <TableCell>{contact.name}</TableCell>
                  <TableCell>{contact.function}</TableCell>
                  <TableCell>{contact.phone}</TableCell>
                  <TableCell>{contact.mobilephone}</TableCell>
                  <TableCell>{contact.email}</TableCell>
                </TableRow>
              ))}
              {contacts?.contacts?.length === 0 && (
                <TableRow>
                  <TableCell colSpan={5} className="text-center">
                    {t("Keine Ansprechpartner gefunden")}
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableCard>
      </MilestonePageContent>
    </MilestonePage>
  );
}
